import { useQuery } from 'react-query';
import customAxios from '../../../axios/custom-axios';

const getReturnItemsPdf = async (returnId) => {
  const token = localStorage.getItem('token');
  customAxios({
    method: 'get',
    responseType: 'arraybuffer',
    url: `/returns/${returnId}/items/pdf`,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      if (response && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `return_${returnId}.pdf`);
        document.body.appendChild(link);
        link.click();
      }
    });
};

const useGetReturnItemsPdf = (returnId) => useQuery(['itemsExcelFile', returnId], () => getReturnItemsPdf(returnId), { enabled: false });

export default useGetReturnItemsPdf;
